export default __webpack_public_path__ + "static/media/9.a3fcd644.gif";